import React, { useEffect, useState } from "react";
import { LegacyCard, EmptyState, IndexTable, Page } from "@shopify/polaris";
import type { NonEmptyArray } from "@shopify/polaris/build/ts/src/types";
import type { IndexTableHeading } from "@shopify/polaris/build/ts/src/components/IndexTable";
import { getHorseVariantsVendors } from "../../api_utils/requests";
import ImportProgressBanner from "../home/support/ImportProgressBanner";
import { Footer } from "../common/Footer";
import { SuppliersIndexPageSkeleton } from "../common/skeletons";
import { SUPPLIERS_HELP_PAGE_URL } from "../../constants";
import HorseLink from "../common/HorseLink";
import { vendorPath } from "../../helper_functions/utils";

const columnNames = [{ title: "Name" }] satisfies NonEmptyArray<IndexTableHeading>;

function VendorsIndex(): React.ReactNode {
  const [pageLoading, setPageLoading] = useState(true);
  const [vendors, setVendors] = useState<string[]>([]);

  useEffect(() => {
    void getHorseVariantsVendors().then(({ vendors: newVendors }) => {
      setVendors(newVendors);
      setPageLoading(false);
    });
  }, []);

  const emptyState = <EmptyState heading="No vendors found" image="" />;

  const pageMarkup = (
    <Page title="Vendors">
      <ImportProgressBanner />
      <LegacyCard>
        <IndexTable
          emptyState={emptyState}
          headings={columnNames}
          itemCount={vendors.length}
          resourceName={{ singular: "Vendor", plural: "Vendors" }}
          selectable={false}
        >
          {vendors.map((vendor, index) => (
            <IndexTable.Row id={vendor} key={vendor} position={index}>
              <IndexTable.Cell>
                <HorseLink url={vendorPath(vendor)}>{vendor}</HorseLink>
              </IndexTable.Cell>
            </IndexTable.Row>
          ))}
        </IndexTable>
      </LegacyCard>
      <Footer pageTitle="vendors" url={SUPPLIERS_HELP_PAGE_URL} />
    </Page>
  );

  return pageLoading ? <SuppliersIndexPageSkeleton /> : pageMarkup;
}

export default VendorsIndex;
